import { useContext, useId } from "react";
import Slider from "react-slick";
import { ConfigContext, CurrentContext, StepContext } from "../App";

/* eslint-disable jsx-a11y/alt-text */

export default function ImageSlider() {
	const [ step ] = useContext( StepContext );
	const current = useContext( CurrentContext );
	const config = useContext( ConfigContext );

	let images: string[];

	const outsideConfig = config.car.car
	                            .filter( c => c.length === current.length )
	                            .filter( c => c.engine === current.engine )
	                            .filter( c => c.transmission === current.transmission )[0];

	const outsideColor = config.carColorOutside.find( c => c.name === current.outside_color )!;

	const insideConfig = config.inside.versions.find( v => v.name === current.inside_version )!;

	const insideColor = config.colorInside.find( c => c.fabricColorName === current.inside_color )!;
	const seats = current.seats;

	if ( step === 0 ) {
		// outside

		images = [
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_1.jpg`,
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_2.jpg`,
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_3.jpg`,
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_4.jpg`,
		];
	} else if ( step === 2 ) {
		// seats

		images = [
			`inside/${outsideConfig.typ}/pkw/${insideColor.path}/${seats}_sitz/img_1.jpg`,
			`inside/${outsideConfig.typ}/pkw/${insideColor.path}/${seats}_sitz/img_2.jpg`,
			`inside/${outsideConfig.typ}/pkw/${insideColor.path}/${seats}_sitz/img_3.jpg`,
		];

	} else if ( step === 5 ) {
		images = [
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_1.jpg`,
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_2.jpg`,
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_3.jpg`,
			`outside/${outsideConfig.typ}/${outsideColor.path}/img_4.jpg`,
			`inside/${outsideConfig.typ}/${insideConfig.version}/${insideColor.path}/img_1.jpg`,
			`inside/${outsideConfig.typ}/${insideConfig.version}/${insideColor.path}/img_2.jpg`,
			`inside/${outsideConfig.typ}/${insideConfig.version}/${insideColor.path}/img_3.jpg`,
			`inside/${outsideConfig.typ}/pkw/${insideColor.path}/${seats}_sitz/img_1.jpg`,
			`inside/${outsideConfig.typ}/pkw/${insideColor.path}/${seats}_sitz/img_2.jpg`,
			`inside/${outsideConfig.typ}/pkw/${insideColor.path}/${seats}_sitz/img_3.jpg`,
		];
	} else {
		// inside

		images = [
			`inside/${outsideConfig.typ}/${insideConfig.version}/${insideColor.path}/img_1.jpg`,
			`inside/${outsideConfig.typ}/${insideConfig.version}/${insideColor.path}/img_2.jpg`,
			`inside/${outsideConfig.typ}/${insideConfig.version}/${insideColor.path}/img_3.jpg`,
		];
	}


	const settings = {
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		className: "slider-root",
		arrows: true,
		dots: true,
		dotsClass: `slick-dots slider-dots`,
	};

	if ( step === 5 ) {
		return (
			<Slider {...settings}>
				<div><img className={"slider-image image-16-9"} src={`./configurator_images/${images[0]}`} /></div>
				<div><img className={"slider-image image-16-9"} src={`./configurator_images/${images[1]}`} /></div>
				<div><img className={"slider-image image-16-9"} src={`./configurator_images/${images[2]}`} /></div>
				<div><img className={"slider-image image-16-9"} src={`./configurator_images/${images[3]}`} /></div>
				<div>
					<div className={"slider-combined"}>
						<img className={"slider-image"} src={`./configurator_images/${images[4]}`} />
						<img className={"slider-image"} src={`./configurator_images/${images[5]}`} />
					</div>
				</div>
				<div><img className={"slider-image"} src={`./configurator_images/${images[6]}`} /></div>
				<div>
					<div className={"slider-combined"}>
						<img className={"slider-image"} src={`./configurator_images/${images[7]}`} />
						<img className={"slider-image"} src={`./configurator_images/${images[8]}`} />
					</div>
				</div>
				<div><img className={"slider-image"} src={`./configurator_images/${images[9]}`} /></div>
			</Slider>
		);
	}

	if ( step !== 0 ) {
		return (
			<Slider {...settings}>
				<div>
					<div className={"slider-combined"}>
						<img className={"slider-image"} src={`./configurator_images/${images[0]}`} />
						<img className={"slider-image"} src={`./configurator_images/${images[1]}`} />
					</div>
				</div>
				<div>
					<img className={"slider-image"} src={`./configurator_images/${images[2]}`} />
				</div>
			</Slider>
		);
	}

	return (
		<Slider {...settings}>
			{images.map( i => <div key={i}>
				<img className={"slider-image"} src={`./configurator_images/${i}`} />
			</div> )}
		</Slider>
	);
}
